import { cva } from 'class-variance-authority';

export const badgesVariants = cva('empty:hidden', {
  variants: {
    variant: {
      default: '',
    },
    position: {
      'default': '',
      'right-top': 'absolute right-4 top-4',
    },
  },
  defaultVariants: {
    variant: 'default',
    position: 'default',
  },
});

// background: linear-gradient(106.31deg, #1F72EE 2.36%, #00B3FF 100%);
export const badgeVariants = cva('', {
  variants: {
    variant: {
      top: 'rounded-2xl bg-gradient-to-r from-[#1F72EE] to-[#00B3FF] font-bold uppercase text-xs px-2 py-1 text-white',
    },
  },
  defaultVariants: {
    variant: 'top',
  },
});
